export const NAME = 'company-general';
